import { CanDeactivateFn } from '@angular/router';
import { WorkflowBuilderComponent } from '../components/settings/workflows/workflow-builder.component';

export const WorkflowUnsavedChangesGuard: CanDeactivateFn<WorkflowBuilderComponent> = (
  component: WorkflowBuilderComponent
): boolean | Promise<boolean> => component.canDeactivateWorkflowBuilder();
